<template>
  <WdsInputArea
    v-model="localModelValue"
    :label="`${fieldTyped.title}${required ? ' *' : ''}`"
    :info="fieldTyped.description ?? undefined"
    :required="required"
    :disabled="props.forceEnabled ? false : !fieldTyped.viewerCanManageFieldValues ?? false"
    :error="error"
    height="70px"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { WdsInputArea } from '@worksome/wds-components'
import { FieldableFormCustomFieldFragment } from '@/components/Fieldable/graphql/fragments'
import { useFragment } from '@/gql'
import { CustomFieldTypeValueInput } from '@/gql/graphql'
import useIsRequiredField from '@/components/Fieldable/composables/useIsRequiredField'
import { FieldableCustomFieldProps } from '@/components/Fieldable/types'

const emits = defineEmits(['update:model-value'])

const props = defineProps<FieldableCustomFieldProps>()

const fieldTyped = computed(() => useFragment(FieldableFormCustomFieldFragment, props.field))
const required = useIsRequiredField(props.field)

const localModelValue = computed<string>({
  get: (): string => props.modelValue?.freeText?.value ?? '',
  set: (input: string) => {
    const value = input === '' ? null : input

    emits('update:model-value', {
      freeText: {
        id: fieldTyped.value.id,
        value,
      },
    } as CustomFieldTypeValueInput)
  },
})
</script>
